import { createReducer } from 'typesafe-actions';
import { defaultErrorHandler, defaultRequestHandler } from '../dataFetching/generators';
import {
    SeoState,
    SliderData,
    SeoData,
    SeoDataRawResponse,
    LinkedBanners,
    LinkedBannersRaw,
    SeoHomePageRawResponce,
} from './types';
import {
    homePageSeoActions,
    HomePageSeoActions,
    fetchSeoDataAction,
    SeoDataActionsType,
    setDefaultSeoAction,
} from './actions';

const mapLinkedBanner = (banner: LinkedBannersRaw): LinkedBanners => ({
    bannerImage: banner.linked_banners_banner_image,
    bannerLink: banner.linked_banners_banner_link,
    desktopBannerImage: banner.linked_banners_banner_desktop_image,
});

export const mapHomePageSeoData = (data: SeoHomePageRawResponce): SeoData => {
    return {
        seoTitle: data.seoTitle,
        seoDescription: data.seoDescription,
        seoText: data.seoText,
        seoTextBottom: data.seoTextBottom,
        availableIn: {},
        mobilePageHeader: data.mobilePageHeader,
        seoHeadline: '',
        metaRobots: '',
        linkedBanners: (data.linkedBanners || []).map(mapLinkedBanner),
        similarPages: data.similarPages,
        seoSlider: null,
        localizedFilters: {},
        similarLinks: [],
    };
};

export const mapSeoData = (data: SeoDataRawResponse): SeoData => {
    let seoSlider: SliderData | null = null;
    if (data.seoSlider && typeof data.seoSlider.main_title === 'string' && data.seoSlider.items) {
        seoSlider = {
            mainTitle: data.seoSlider.main_title,
            items: data.seoSlider.items.map(item => ({
                title: item.title,
                topicTitle: item.topic_title,
                ctaText: item.cta_text,
                image: item.image,
                link: item.link,
            })),
        };
    }

    return {
        seoTitle: data.seoTitle,
        seoDescription: data.seoDescription,
        seoText: data.seoText,
        text: data.text,
        seoTextBottom: data.seoTextBottom,
        /* eslint-disable @typescript-eslint/camelcase, camelcase */
        availableIn: data.available_in || {},
        mobilePageHeader: data.mobilePageHeader,
        seoHeadline: data.seoHeadline,
        metaRobots: data.seoRobots,
        linkedBanners: (data.linkedBanners || []).map(mapLinkedBanner),
        similarPages: data.similarPages || [],
        seoSlider,
        localizedFilters: data.localized_filters || {},
        similarLinks: data.similarLinks,
    };
};

const defaultSeoState = {
    seoData: {
        seoTitle: '',
        seoDescription: '',
        availableIn: {},
        mobilePageHeader: '',
        seoHeadline: '',
        linkedBanners: [],
        hasBannerPlaceHolder: true,
        isFetching: false,
        didInvalidate: false,
        identifier: '',
        similarPages: [],
        seoSlider: null,
        localizedFilters: {},
        similarLinks: [],
    },
    isFetching: false,
    didInvalidate: false,
    identifier: '',
};

export const seoReducer = createReducer<SeoState, SeoDataActionsType>(defaultSeoState)
    .handleAction(fetchSeoDataAction.success, (state, action) => {
        return {
            ...state,
            seoData: { ...mapSeoData(action.payload.data.data || {}) },
            isFetching: false,
        };
    })
    .handleAction(fetchSeoDataAction.failure, (state, action) => defaultErrorHandler(state, action))
    .handleAction(fetchSeoDataAction.request, (state, action) => defaultRequestHandler(state, action))
    .handleAction(setDefaultSeoAction, (state, action) => {
        return {
            ...state,
            identifier: action.payload.identifier,
            seoData: action.payload.data,
            isFetching: false,
        };
    });

export const homePageSeoReducer = createReducer<SeoState, HomePageSeoActions>(defaultSeoState)
    .handleAction(homePageSeoActions.actions.success, (state, action) => {
        return {
            ...state,
            seoData: { ...mapSeoData(action.payload.data.data || {}) },
        };
    })
    .handleAction(homePageSeoActions.actions.failure, (state, action) => defaultErrorHandler(state, action))
    .handleAction(homePageSeoActions.actions.request, (state, action) => defaultRequestHandler(state, action));
